import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

/** Placeholder while content loads; reserves space so the page does not jump. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div aria-hidden="true" className={cn("animate-pulse rounded-md bg-surface-sunken", className)} {...props} />;
}
